import { ErrorController } from "./core/error/error.controller";
import { MaintenanceController } from "./core/maintenance/maintenance.controller";
import { STATE, V2_STATES_REDIRECT } from "./thor.const";
import { auth as authT } from "./typings/auth";

class ThorRoutes {
    public static $inject: string[] = ["$stateProvider"];

    constructor($stateProvider: angular.ui.IStateProvider) {
        $stateProvider
            .state(STATE.THOR.ABSTRACT, {
                abstract: true,
                url: "",
                template: "<div ui-view layout-fill ng-class='containerClass'></div>",
                data: {
                    containerClass: "",
                    title: ""
                },
                resolve: {
                    initUser:
                        [
                            "$q", "aclService", "authService", "sitesService", "thorService", "io",
                            (
                                $q: ng.IQService,
                                aclService,
                                authService,
                                sitesService,
                                thorService,
                                io
                            ) => {
                            const deferred = $q.defer();

                            return authService.refreshAccessToken()
                                .then(() => {
                                    // init broker connection
                                    io.manualOpen();

                                    return authService.fetchOrganization();
                                })
                                .then(() => {
                                    const role = authService.getRole();
                                    if (role === authT.Roles.Organizations) {
                                        const organization = authService.organization || {};
                                        if (!sitesService.organizationCanPublish(organization, sitesService.site)) {
                                            deferred.reject({ redirectStateName: STATE.ERROR["403"] });
                                            return deferred.promise;
                                        }
                                    }
                                    return aclService.initAuthorizedPermissions();
                                });
                    }],
                    // initUser is injected here to ensure that it's resolved before resolving categories
                    categories: [
                        "$rootScope",
                        "initUser",
                        "categoryService",
                        ($rootScope: ng.IRootScopeService) => ($rootScope.isThorBooting = false)
                    ]
                },
                onExit: ["timingService", timing => timing.stopInterval()]
            })
            .state(STATE.THOR.MAIN, {
                url: "",
                template: `
                    <thor-sidenav></thor-sidenav>
                    <div
                        layout="column"
                        layout-fill
                        role="main"
                    >
                        <thor-topbar></thor-topbar>
                        <md-content
                            layout="column"
                            layout-fill
                            flex
                            ui-view
                            class="thor-main
                            md-content-visible"
                        ></md-content>
                    </div>
                    <need-help-btn class="fab-bottom-right"></need-help-btn>
                    <thor-overlay-video></thor-overlay-video>
                `,
                resolve: {
                    paymentContracts: [
                        "$q",
                        "authService",
                        "contractService",
                        "initUser",
                        (
                            $q: ng.IQService,
                            authService,
                            contractService
                        ) => {
                            return $q((resolve, _) => {
                                if (!authService.organization || authService.role === authT.Roles.Visitor) {
                                    resolve();
                                } else {
                                    contractService.get(authService.organization.id)
                                        .finally(() => resolve());
                                }
                            });
                        }
                    ]
                }
            })
            .state(STATE.ERROR.MAINTENANCE, {
                url: "/maintenance",
                templateUrl: "/app/core/maintenance/maintenance.html",
                controller: MaintenanceController,
                controllerAs: "maintenanceCtrl",
                data: {
                    containerClass: "",
                    title: "maintenance"
                },
                resolve: {
                    maintenanceData: [
                        "$q",
                        "$rootScope",
                        "maintenanceService",
                        ($q: ng.IQService, $rootScope: ng.IRootScopeService, maintenanceService) => {
                            const deferred = $q.defer();

                            maintenanceService.fetchResponse
                                .then(res => {
                                    if (res && res.data.status === "present") {
                                        deferred.resolve(res.data);
                                    } else {
                                        deferred.reject({ redirectStateName: STATE.V2.HOME.name });
                                    }
                                })
                                .finally(() => ($rootScope.isThorBooting = false));

                            return deferred.promise;
                        }
                    ]
                }
            })
            .state(STATE.ERROR.MAIN, {
                url: "/error",
                template: require("./core/error/error.html"),
                controller: ErrorController,
                controllerAs: "errorCtrl",
                data: {
                    containerClass: "",
                    title: "erreur"
                },
                resolve: {
                    // end booting
                    _: ["$rootScope", ($rootScope: ng.IRootScopeService) => ($rootScope.isThorBooting = false)]
                }
            })
            .state(STATE.ERROR["403"], {
                url: "/403",
                template: require("./core/error/403.html"),
                data: {
                    containerClass: "",
                    title: ["erreur_code", { CODE: 403 }]
                },
                resolve: {
                    _: ["$rootScope", ($rootScope: ng.IRootScopeService) => ($rootScope.isThorBooting = false)]
                }
            });

        V2_STATES_REDIRECT.forEach((state: { name: string; url: string }) => $stateProvider.state({
            ...state,
            resolve: {
                _: ["$window", ($window: ng.IWindowService) => $window.open(state.url, "_self")]
            }
        }));
    }
}

angular
    .module("thor.routes", [])
    .config(ThorRoutes);
